// extracted by mini-css-extract-plugin
module.exports = {"accent-100":"card_accent-100__xVpUV","accent-50":"card_accent-50__TaGbw","primary-100":"card_primary-100__5fyPB","primary-50":"card_primary-50__loAN_","root":"card_root__EakR7"};